import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { horizontalStyles } from "@insite/mobius/Tag";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

savedOrderListFilterStyles.orderTotalContainer = {
    css: css`
        > div {
            div[class^="FormFieldStyle"] {
                label {
                    color: ${getColor("text.main")};
                }
            }

            div[class^="FormInputWrapper"] {
                select {
                    height: 48px !important;
                }
                input {
                    height: 48px !important;
                }
                span[class^="IconWrapper"] {
                    top: 6px;
                }
            }
        }
    `,
};
savedOrderListFilterStyles.orderTotalGridItem = {
    width: [12, 12, 6, 6, 4],
};
savedOrderListFilterStyles.orderTotalOperatorGridItem = { width: [12, 6, 6, 6, 6] };
savedOrderListFilterStyles.orderTotalAmountGridItem = {
    width: [12, 6, 6, 6, 6],
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding-top: 0;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
savedOrderListFilterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        margin-right: 10px;
        margin-bottom: 19px;
        /* border-radius: 0px;
        padding: 10px 34px;
        margin-right: 0;
        background: ${getColor("common.background")};
        border: 2px solid ${COLORS.primary.base};
        span[class^="TypographyStyle"] {
            color: ${getColor("text.main")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            opacity: 0.3;
            background: none !important;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 8px 25px;
                `,
                css`
                    padding: 8px 25px;
                `,
                null,
                null,
                null,
            ])} */
    `,
};

savedOrderListFilterStyles.heading = {
    variant: "h5",
    css: css`
        margin: 0;
        color: ${getColor("text.main")};
    `,
};

savedOrderListFilterStyles.datesGridItem = {
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                css`
                    padding-left: 15px;
                `,
                null,
                null,
                null,
            ])}
        div[class^="react-datetime-picker"] {
            width: 21rem !important;
        }

        div[class^="FormInputWrapper"] .react-datetime-picker__clear-button svg {
            margin-bottom: -4px;
        }
    `,
    width: [12, 12, 12, 12, 12],
};
savedOrderListFilterStyles.toDate = {
    cssOverrides: {
        formField: css`
            gap: 2px;
            label {
                color: ${getColor("text.main")};
            }
        `,
        datePicker: css`
        `,
    },
};

savedOrderListFilterStyles.orderTotalAmountTextField = {
    cssOverrides: {
        formInputWrapper: css`
            margin-top: 26px;
        `,
    },
};

savedOrderListFilterStyles.fromDate = {
    cssOverrides: {
        formField: css`
            label {
                color: ${getColor("text.main")};
            }
        `,
    },
};
savedOrderListFilterStyles.fromGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        > div {
            div[class^="FormInputWrapper"] {
                margin-top: 2px !important;
                width: 100% !important;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    width: 100%;
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    width: 100%;
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                null,
                null,
            ])}
        @media (min-width: 992px) and (max-width: 1100px) {
            max-width: 100% !important;
        }
    `,
};
savedOrderListFilterStyles.toGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        > div {
            div[class^="FormInputWrapper"] {
                margin-top: 2px !important;
                width: 100% !important;
            }
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    width: 100%;
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                css`
                    width: 100%;
                    flex-basis: 100%;
                    max-width: 100%;
                `,
                null,
                null,
            ])}
        div[class^="react-calendar"] {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        left: auto;
                        right: 0;
                    `,
                    css`
                        left: auto;
                        right: 0;
                    `,
                    css`
                        left: auto;
                        right: 0;
                    `,
                ])}
        }
        @media (min-width: 992px) and (max-width: 1100px) {
            div[class^="react-datetime-picker"] {
                padding: 0px !important;
                max-width: 100% !important;
            }
            span[class^="IconWrapper"] {
                padding-left: 2px !important;
                width: 40px !important;
                svg {
                    height: 20px;
                    width: 20px;
                }
            }
        }
    `,
};
savedOrderListFilterStyles.appliedFiltersContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        > div {
            border-radius: 0;
            padding: 7px 21px;
            background: ${getColor("primary")};
            &:hover {
                background: ${getColor("text.accent")};
            }
            > span {
                display: flex;
                align-items: center;
            }
            > button {
                background: transparent;
                &:hover {
                    background: ${getColor("text.accent")};
                }
                > span[class^="IconWrapper"] {
                    top: 0.125em;
                    > svg {
                        color: ${getColor("primary.contrast")};
                    }
                }
            }
        }
    `,
};
